import { FilterOption, appendNotSpecifiedFilterOption } from "./filter-helpers";

/**
 * Create static category filter options for Condition data
 * Returns Problem List Item and Encounter Diagnosis categories
 */
export function createConditionCategoryFilters(): FilterOption[] {
  const filters: FilterOption[] = [
    {
      label: "Problem List Item",
      groupLabel: "Category",
      value: "category:Problem List Item",
    },
    {
      label: "Encounter Diagnosis",
      groupLabel: "Category",
      value: "category:Encounter Diagnosis",
    },
  ];

  // Automatically add "Not Specified" for each group
  return appendNotSpecifiedFilterOption(filters);
}
